import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';

/**
 * Homepage class.
 */
export default class Fade extends withIntersectionObserver(Base, {
  threshold: 0.3,
}) {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Fade',
    options: {
      delay: {
        type: Number,
        default: 0.2,
      },
    },
  };

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  intersected(entries) {
    if (entries[0].isIntersecting) {
      this.launchAnimation();
    }
  }

  /**
   *
   */
  launchAnimation() {
    const delay = this.$options.delay === 0.2 ? this.$options.delay : this.$options.delay / 5;
    if (this.$el.classList.contains('inview')) {
      return;
    }
    this.$el.classList.add('inview');

    gsap.fromTo(
      this.$el,
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1.8,
        delay,
        ease: 'power4.out',
        clearProps: 'transform',
        onStart: () => {
          this.$terminate();
        },
      },
    );
  }
}
